export default "__VITE_ASSET__Wi5XKp5v__"